import { render, staticRenderFns } from "./ShipmentTypeBadge.vue?vue&type=template&id=805b4878"
import script from "./ShipmentTypeBadge.vue?vue&type=script&lang=js"
export * from "./ShipmentTypeBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports